import { render, staticRenderFns } from "./parcel-detail-block-log.vue?vue&type=template&id=0f9934e2"
import script from "./parcel-detail-block-log.vue?vue&type=script&lang=js"
export * from "./parcel-detail-block-log.vue?vue&type=script&lang=js"
import style0 from "./parcel-detail-block-log.vue?vue&type=style&index=0&id=0f9934e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports